import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "center-box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logged-out-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  })
], -1)

import { inject } from "vue";
import { authService } from "@/auth/authSingleton";
import { useRouter } from "vue-router";
import { IAPILogger } from "@/interfaces/IAPILogger";
import { RoutePaths } from "@/router/RouteDetails";
import { routes } from "@/router";
import { AuthorisationLevel, GetAuthLevel } from "@/config/AuthConfig";
import { AuthState } from "@/auth/authStates";
import log from "loglevel";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

document.title = 'Login - UV'

const router = useRouter();
const Logger: IAPILogger = inject("Logger")!;

function OnLoginRouteExceptions() {
    const transferPaymentRouteElement = routes.find(route => route.name === "Transfer Payments");
    const hireAgreementPdfRouteElement = routes.find(route => route.name === "Hire Agreement (PDF)");

    if (transferPaymentRouteElement) {
        transferPaymentRouteElement.meta = transferPaymentRouteElement.meta || {};
        transferPaymentRouteElement.meta.authLevel = GetAuthLevel(authService.getUsersRole()) === AuthorisationLevel.DepositManager ? AuthorisationLevel.DepositManager : AuthorisationLevel.Analyst;
    }
    if (hireAgreementPdfRouteElement) {
        hireAgreementPdfRouteElement.meta = hireAgreementPdfRouteElement.meta || {};
        hireAgreementPdfRouteElement.meta.authLevel = GetAuthLevel(authService.getUsersRole()) === AuthorisationLevel.External ? AuthorisationLevel.External : AuthorisationLevel.Operator;
    }
}

async function onLogin() {
    const loggedIn = await authService.isLoggedIn() == AuthState.LOGGED_IN;
    if (!loggedIn) {
        const loginSuccess = await authService.login();
            if (loginSuccess) {
                OnLoginRouteExceptions();
                const name = onLogin.name.toString();
                const Message = "Logged in.";
                const Class = name;
                Logger.LogInformation(Message, Class);
                router.push({
                    path: (router.currentRoute.value.query.redirect as string) ?? RoutePaths.Home,
                });
            }
    }else {
        log.error("Login failed.");
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", {
      onClick: onLogin,
      class: "login-button"
    }, "LOGIN")
  ]))
}
}

})